import { ApiService, toData } from '~/shared/api'
import type { ApiDataResponse } from '~/shared/types/api'
import type { EcosystemItem } from '~/types/ecosystem'

type EcosystemMenuResponse = ApiDataResponse<EcosystemItem[]>

export class EcosystemService extends ApiService {
  readonly urls = {
    popular: '/api/v1/yavagro/menu/popular',
    platform: '/api/v1/yavagro/menu/platform',
  }

  public getOtherServicesMenuList(): Promise<EcosystemItem[]> {
    return this.http.request<EcosystemMenuResponse>({ url: this.urls.platform }).then(toData())
  }

  public getPopularServicesMenuList(): Promise<EcosystemItem[]> {
    return this.http.request<EcosystemMenuResponse>({ url: this.urls.popular }).then(toData())
  }
}
